import React, { Component, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { CContainer, CSpinner, CButton } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilChartPie } from '@coreui/icons'
// routes config
import routes from '../routes'
import Pageloader from './shared/Pageloader'
import { getStoredAppRole } from '../utils/handleCookie'

class RouteLoadErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error) {
    console.error('Route load failed:', error)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex min-vh-100 align-items-center justify-content-center text-white">
          <div className="text-center">
            <h5>Unable to load this page</h5>
            <p className="mb-3">The app lost connection while loading a module. Please reload the page.</p>
            <CButton color="primary" onClick={() => window.location.reload()}>
              Reload
            </CButton>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

const AppContent = () => {
  const roleAc = getStoredAppRole()
  const isCallCenterRole = roleAc === 'callcenter'

  if (isCallCenterRole && window.location.pathname !== '/dashboard/callcenter') {
    return <Redirect to="/dashboard/callcenter" />
  }

  return (
   
    <div lg className="p-0 m-0 ">
      <RouteLoadErrorBoundary>
        <Suspense fallback={<Pageloader isLoading={true} />}>
          <Switch>
            {routes.map((route, idx) => {
              return (
                route.component && (
                  <Route
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={(props) => (
                      <>
                        <route.component {...props} />
                      </>
                    )}
                  />
                )
              )
            })}
            <Redirect from="/" to={isCallCenterRole ? '/dashboard/callcenter' : roleAc === 'provider' ? '/home/provider/today-appointment' : '/home/appointment'} />
          </Switch>
          {/* <CButton className="floating-button" color="primary" onClick={() => alert('Settings clicked')}>
      <CIcon icon={cilChartPie} height={36}></CIcon>
    </CButton> */}
        </Suspense>
      </RouteLoadErrorBoundary>
    </div>
  )
}

export default React.memo(AppContent)
